<template>
  <div class="tree-node">
    <div
      class="folder-header"
      :class="{ active: selectedId === node.id }"
      @click="$emit('select', node)"
    >
      <div class="folder-left">
        <i
          class="ti"
          :class="hasChildren ? (node.open ? 'ti-chevron-down' : 'ti-chevron-right') : ''"
        ></i>
        <input
          v-if="depth > 0"
          type="checkbox"
          :checked="node.checked"
          @click.stop
          @change="$emit('toggle-checked', { node, checked: $event.target.checked })"
        >

        <i
          class="ti folder-icon"
          :class="hasChildren ? (node.open ? 'ti-folder-open' : 'ti-folder') : 'ti-file-description'"
        ></i>

        <span class="folder-title">
          {{ node.name }}
        </span>
      </div>

      <div class="folder-right d-flex align-items-center gap-2">
        <span class="count" v-if="hasChildren">
          {{ node.children.length }}
        </span>

        <button class="action-btn add-btn" title="Add Child" @click.stop="$emit('add', node)">
          <i class="fa-solid fa-plus"></i>
        </button>

        <button class="action-btn edit-btn" title="Edit" @click.stop="$emit('edit', node)">
          <i class="fa-solid fa-pen-to-square"></i>
        </button>

        <button class="action-btn delete-btn" title="Delete" @click.stop="$emit('delete', node)">
          <i class="fa-solid fa-trash"></i>
        </button>
      </div>
    </div>

    <transition name="fade">
      <div
        v-show="node.open && hasChildren"
        class="children"
        :style="{ paddingLeft: (depth + 1) * 16 + 'px' }"
      >
        <tree-node
          v-for="child in node.children"
          :key="child.id"
          :node="child"
          :depth="depth + 1"
          :selected-id="selectedId"
          @select="$emit('select', $event)"
          @add="$emit('add', $event)"
          @edit="$emit('edit', $event)"
          @delete="$emit('delete', $event)"
          @toggle-checked="$emit('toggle-checked', $event)"
        />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "TreeNode",

  props: {
    node: {
      type: Object,
      required: true
    },
    depth: {
      type: Number,
      default: 0
    },
    selectedId: {
      type: [String, Number],
      default: null
    }
  },

  computed: {
    hasChildren() {
      return !!(this.node.children && this.node.children.length > 0);
    }
  }
};
</script>

<style scoped>
.folder-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 4px;
  cursor: pointer;
  border-radius: 6px;
}

.folder-header:hover {
  background-color: #f9fafb;
}

.folder-header.active {
  background-color: #eef2ff;
}

.folder-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.folder-title {
  font-size: 11px;
}

.folder-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.children {
  border-left: 2px dashed #8b8f94;
  margin-left: 10px;
}

.action-btn {
  width: auto;
  height: auto;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 4px;
  transition: 0.2s;
}

.action-btn i {
  font-size: 12px;
  transition: 0.2s;
}

.add-btn i {
  color: #3b82f6;
}
.add-btn:hover i {
  color: #1d4ed8;
  transform: scale(1.15);
}

.edit-btn i {
  color: #4f46e5;
}
.edit-btn:hover i {
  color: #3730a3;
  transform: scale(1.15);
}

.delete-btn i {
  color: #f87171;
}
.delete-btn:hover i {
  color: #dc2626;
  transform: scale(1.15);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>